export function normalizeFeatureFlags(flags) {
  return {
    debugStaticGraph: Boolean(flags?.debugStaticGraph),
    ...flags,
  };
}

export function normalizeQueue(payload) {
  if (!payload || Array.isArray(payload)) {
    return null;
  }

  return payload.queue || payload.data?.queue || payload.data || payload;
}

export function normalizeJob(payload) {
  if (!payload || Array.isArray(payload)) {
    return null;
  }

  return payload.job || payload.data?.job || payload.data || payload;
}
